module.exports = __webpack_public_path__ + "img/homepage-premium.c9fa6f7c.png";